import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export interface IReelsBasePayload {
    reels_id: number;
    reels_developer: string;
    reels_name: string;
}

const normalizeDataForGTM = (data: IReelsBasePayload) => {
    return {
        ...data,
        reels_id: `${data.reels_id}`
    };
};

const reelsShownEvent = (data: IReelsBasePayload[]) => {
    hitGoogleTagManager({
        event: "reels_display",
        event_action: "banner_display",
        reels_table: data.map(normalizeDataForGTM)
    });
};

const reelClickEvent = (data: IReelsBasePayload) => {
    hitGoogleTagManager({
        event: "reels",
        event_action: "click",
        reels_table: [normalizeDataForGTM(data)]
    });
};

/**
 * @param reelIndex - index of reel in the list, should be from 1 to n
 * @param percentageOfReelViewing - 0 on start, 50 on middle, 100 on end
 */
const reelViewEvent = (data: IReelsBasePayload, percentageOfReelViewing = 0 | 90) => {
    hitGoogleTagManager({event: "reels", event_action: percentageOfReelViewing === 90 ? "view_90" : "view", reels_table: [normalizeDataForGTM(data)]});
};

const reelNavigationEvent = () => {
    hitGoogleTagManager({event: "reels", event_action: "skip"});
};

const reelCloseEvent = () => {
    hitGoogleTagManager({event: "reels", event_action: "close"});
};

const reelButtonClickEvent = (data: IReelsBasePayload) => {
    hitGoogleTagManager({event: "reels", event_action: "button", reels_table: [normalizeDataForGTM(data)]});
};

const reelShareEvent = (data: IReelsBasePayload) => {
    hitGoogleTagManager({event: "reels", event_action: "share", reels_table: [normalizeDataForGTM(data)]});
};

export const reelsAnalytics = {
    gtm: {
        reelsShownEvent,
        reelClickEvent,
        reelViewEvent,
        reelNavigationEvent,
        reelCloseEvent,
        reelButtonClickEvent,
        reelShareEvent
    }
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export interface IReelsBasePayload {
    reels_id: number;
    reels_developer: string;
    reels_name: string;
}

const normalizeDataForGTM = (data: IReelsBasePayload) => {
    return {
        ...data,
        reels_id: `${data.reels_id}`
    };
};

const reelsShownEvent = (data: IReelsBasePayload[]) => {
    hitGoogleTagManager({
        event: "reels_display",
        event_action: "banner_display",
        reels_table: data.map(normalizeDataForGTM)
    });
};

const reelClickEvent = (data: IReelsBasePayload) => {
    hitGoogleTagManager({
        event: "reels",
        event_action: "click",
        reels_table: [normalizeDataForGTM(data)]
    });
};

/**
 * @param reelIndex - index of reel in the list, should be from 1 to n
 * @param percentageOfReelViewing - 0 on start, 50 on middle, 100 on end
 */
const reelViewEvent = (data: IReelsBasePayload, percentageOfReelViewing = 0 | 90) => {
    hitGoogleTagManager({event: "reels", event_action: percentageOfReelViewing === 90 ? "view_90" : "view", reels_table: [normalizeDataForGTM(data)]});
};

const reelNavigationEvent = () => {
    hitGoogleTagManager({event: "reels", event_action: "skip"});
};

const reelCloseEvent = () => {
    hitGoogleTagManager({event: "reels", event_action: "close"});
};

const reelButtonClickEvent = (data: IReelsBasePayload) => {
    hitGoogleTagManager({event: "reels", event_action: "button", reels_table: [normalizeDataForGTM(data)]});
};

const reelShareEvent = (data: IReelsBasePayload) => {
    hitGoogleTagManager({event: "reels", event_action: "share", reels_table: [normalizeDataForGTM(data)]});
};

export const reelsAnalytics = {
    gtm: {
        reelsShownEvent,
        reelClickEvent,
        reelViewEvent,
        reelNavigationEvent,
        reelCloseEvent,
        reelButtonClickEvent,
        reelShareEvent
    }
};
